import type { GalleryNavigationClickEventHandler } from '@hotels-hotel-detail/ui/types';
import type { I18nService } from '@shared/types/i18n';

import { useHotelImagesContext } from '@hotels-hotel-detail/data-access/hooks/useHotelImagesContext';
import GalleryNavigation from '@hotels-hotel-detail/ui/GalleryNavigation';
import MediaGallery from '@hotels-hotel-detail/ui/MediaGallery';
import { getCombinedImagesGalleryProps } from '@hotels-hotel-detail/utils/hotel-images';
import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';
import withScrimmedPortal from '@shared/ui/common/withScrimmedPortal';
import { withI18n } from '@shared/ui/contexts/i18n';

const FullScreenMediaGallery = withScrimmedPortal(MediaGallery);

type Props = {
  onClose: () => void;
  i18n: I18nService;
};

const DetailsPageGallery = ({ i18n, onClose }: Props) => {
  const {
    galleryIndex,
    images,
    isLoading,
    selectedType,
    setSelectedNavType,
    showNavigation,
  } = useHotelImagesContext();

  if (!images.hotel.items?.length) {
    return null;
  }

  const onNavClick: GalleryNavigationClickEventHandler = (type) => {
    setSelectedNavType(type);
  };

  const getProps = (isMobile: boolean) => {
    if (!isMobile) {
      return images[selectedType];
    }
    return getCombinedImagesGalleryProps({
      images,
      translate: i18n.translate,
    });
  };

  return (
    <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
      {(isMobile: boolean) => (
        <FullScreenMediaGallery
          isOpen
          onClose={onClose}
          isLoading={isLoading}
          startIndex={galleryIndex}
          galleryView={!isMobile && showNavigation}
          infinite={!isMobile}
          {...getProps(isMobile)}
          navigation={
            showNavigation && !isMobile && images.traveller.items?.length ? (
              <GalleryNavigation
                selectedNav={selectedType}
                hotelImageGalleryLength={images.hotel.items?.length ?? 0}
                travellerImageGalleryLength={images.traveller.items?.length}
                onNavClick={onNavClick}
              />
            ) : null
          }
        />
      )}
    </BpkBreakpoint>
  );
};

export default withI18n(DetailsPageGallery);
